/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiAssistanceRequestAdditionalDetails
 */
export interface ApiAssistanceRequestAdditionalDetails {
    /**
     * 
     * @type {string}
     * @memberof ApiAssistanceRequestAdditionalDetails
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAssistanceRequestAdditionalDetails
     */
    description?: string;
}

export function ApiAssistanceRequestAdditionalDetailsFromJSON(json: any): ApiAssistanceRequestAdditionalDetails {
    return ApiAssistanceRequestAdditionalDetailsFromJSONTyped(json, false);
}

export function ApiAssistanceRequestAdditionalDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiAssistanceRequestAdditionalDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function ApiAssistanceRequestAdditionalDetailsToJSON(value?: ApiAssistanceRequestAdditionalDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'description': value.description,
    };
}

